module.exports = __webpack_public_path__ + "img/afecb64.png";